module.exports = __webpack_public_path__ + "fonts/DroidKufi-Bold.da270dfc.eot";